import styled from '@emotion/styled'
import {
  FlexBox,
  PageContainer,
  Centralizer,
  InfoWithImageFlexBox,
} from 'jmt-styled-components'

import { useTranslation } from '../utils/custom-hooks/useTranslation'
import { Button } from '../components/base/buttons/Button'
import errorImage from '../assets/images/error-general.png'
import { Card } from '../components/base/layouts/Card'

const ErrorTitle = styled.h2`
  padding-bottom: 10px;
`

const ErrorBody = styled.div`
  padding-bottom: 10px;

  a {
    color: ${(p) => p.theme.primaryColor};
    font-weight: bold;
  }
`

export const MaintenanceRoute = () => {
  const { t } = useTranslation()

  return (
    <PageContainer>
      <Centralizer>
        <Card padding="20px 30px">
          <InfoWithImageFlexBox>
            <div>
              <img src={errorImage} alt="Maintenance" />
            </div>
            <FlexBox dir="column">
              <ErrorTitle>{t('Maintenance_Page-Info-Title')}</ErrorTitle>
              <ErrorBody
                dangerouslySetInnerHTML={{
                  __html: t('Maintenance_Page-Info-Description').replace(/(?:\r\n|\r|\n)/g, '<br />'),
                }}
              />
              <ErrorBody
                dangerouslySetInnerHTML={{
                  __html: t('Maintenance_Page-Info-Advice').replace(/(?:\r\n|\r|\n)/g, '<br />'),
                }}
              />
              <Button
                onClick={() => {
                  window.location.href = window.location.origin
                }}
              >
                {t('Maintenance_Page-Info-Button-Title')}
              </Button>
            </FlexBox>
          </InfoWithImageFlexBox>
        </Card>
      </Centralizer>
    </PageContainer>
  )
}
